var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAntiFraud = function SvgIconAntiFraud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9761",
    "data-name": "Grupo 9761",
    transform: "translate(-578 -254.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9759",
    "data-name": "Grupo 9759",
    transform: "translate(620.339 276.165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4270",
    "data-name": "Ret\\xE2ngulo 4270",
    width: 76,
    height: 96,
    rx: 10,
    transform: "translate(-0.339 15.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4271",
    "data-name": "Ret\\xE2ngulo 4271",
    width: 38,
    height: 97,
    rx: 6,
    transform: "translate(18.661 0.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5955",
    "data-name": "Caminho 5955",
    d: "M79.519,20.771a10.98,10.98,0,0,0-3.638-.7c-1.418-.083-2.8-.065-4.268-.046-.637.009-1.279.015-1.934.015h-.75V13.858c0-.434-.009-.868-.015-1.306-.015-.985-.034-2,.034-3.018A3.3,3.3,0,0,0,67.145,6H29.174a3.11,3.11,0,0,0-1.857,3.31c.08,2.374.065,4.616.049,6.993-.006.988-.012,1.983-.012,2.993v.754H26.6c-.707,0-1.405-.006-2.094-.009-1.547-.009-3.01-.018-4.5.018A8.7,8.7,0,0,0,12.76,23.97a8.967,8.967,0,0,0-1.577,5.352v77.567c0,5.441,2.337,8.483,7.577,9.859a.844.844,0,0,1,.237.1H77.382a2.422,2.422,0,0,1,.341-.145l.1-.025a8.862,8.862,0,0,0,7.22-8.354c.031-.406.04-.788.04-1.17q-.014-38.7,0-77.413C85.078,25.328,83.261,22.393,79.519,20.771ZM32.692,11.392a1.71,1.71,0,0,1,1.261-.428q14.267.023,28.533.022a3.839,3.839,0,0,1,.461.037l.935.1V37.272H32.412l-.083-.967a7.029,7.029,0,0,1-.049-.721q.009-11.408-.015-22.81A1.882,1.882,0,0,1,32.692,11.392ZM80.085,29.937v77.016c0,3.489-1.415,4.911-4.886,4.911H20.964c-3.376,0-4.816-1.456-4.816-4.871V29.87c0-3.4,1.448-4.843,4.846-4.843h6.3l-.012,12.326-1.516-.006c-.477-.006-.938-.012-1.4.006a2.388,2.388,0,0,0-1.79.684,2.458,2.458,0,0,0,1.654,4.231c.351.025.661.022.966.022H71.019c.344,0,.686,0,1.024-.028a2.457,2.457,0,0,0-.1-4.9c-.458-.018-.922-.012-1.405-.006l-1.544.006V25.118h.75c.7,0,1.408-.009,2.106-.018,1.648-.022,3.352-.043,5.031.059A3.763,3.763,0,0,1,80.069,28.7c.025.289.022.61.018.93Z",
    transform: "translate(-10.374 -6)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5956",
    "data-name": "Caminho 5956",
    d: "M66.791,37.016q.018-7.142,0-14.28l.009-.112a2.716,2.716,0,0,0,0-.756,2.571,2.571,0,0,0-1.007-1.695A2.507,2.507,0,0,0,63.9,19.7l-.113.009H40.832q-11.593,0-23.176,0a3.038,3.038,0,0,0-.728-.009,2.543,2.543,0,0,0-1.711.983,2.62,2.62,0,0,0-.526,1.922c0,4.854,0,9.615.006,14.376a2.939,2.939,0,0,0-.006.768,2.577,2.577,0,0,0,.964,1.732,2.514,2.514,0,0,0,1.879.529c15.5,0,30.914,0,46.325-.006h.055l.052.006a2.364,2.364,0,0,0,.725,0A2.537,2.537,0,0,0,66.8,37.131ZM61.808,34.9H19.725V24.8H61.808Z",
    transform: "translate(-3.014 22.332)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5957",
    "data-name": "Caminho 5957",
    d: "M26.859,28.112c-3.153-.022-6.31-.022-9.419,0a2.96,2.96,0,0,0-.4,0,2.529,2.529,0,1,0,.345,5.047c1.067.012,2.068.009,3.069,0l1.514,0,4.963,0h.012a2.55,2.55,0,0,0,2.55-2.534v-.174a2.471,2.471,0,0,0-.821-1.695A2.541,2.541,0,0,0,26.859,28.112Z",
    transform: "translate(-2.992 39.909)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5958",
    "data-name": "Caminho 5958",
    d: "M23.361,33.152c3.135.025,6.251.025,9.323,0a3.254,3.254,0,0,0,.429,0,2.531,2.531,0,0,0-.37-5.047c-1.073-.009-2.1-.006-3.128,0l-1.549,0-1.623,0c-1,0-2-.006-3.007,0a3.146,3.146,0,0,0-.451,0,2.532,2.532,0,1,0,.376,5.05Z",
    transform: "translate(9.174 39.906)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5959",
    "data-name": "Caminho 5959",
    d: "M26.725,31.968c-3.128-.019-6.176-.016-9.23,0a3.736,3.736,0,0,0-.491,0,2.541,2.541,0,0,0-2.317,2.737,2.555,2.555,0,0,0,2.733,2.317c1.1.009,2.124.006,3.15,0l1.549-.006,1.592,0c.98.006,1.953.006,2.929,0a3,3,0,0,0,.554,0,2.539,2.539,0,1,0-.47-5.056Z",
    transform: "translate(-2.992 47.929)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5960",
    "data-name": "Caminho 5960",
    d: "M23.3,37.019c1.076.012,2.1.009,3.128,0l1.552,0,4.758.006A2.572,2.572,0,0,0,35.443,34.5a2.6,2.6,0,0,0-2.64-2.522c-3.175-.034-6.363-.031-9.513,0a2.389,2.389,0,0,0-.261,0,2.523,2.523,0,1,0,.271,5.038Z",
    transform: "translate(9.176 47.931)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5961",
    "data-name": "Caminho 5961",
    d: "M29.273,33.16c1.107.012,2.158.006,3.209,0l1.586,0,1.508,0c1,0,2.006.006,3.007,0a3.938,3.938,0,0,0,.46.006,2.534,2.534,0,0,0-.351-5.056c-3.144-.019-6.232-.019-9.317,0a3.033,3.033,0,0,0-.339,0,2.527,2.527,0,1,0,.236,5.047Z",
    transform: "translate(21.454 39.908)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5962",
    "data-name": "Caminho 5962",
    d: "M29.337,37.029c1.073,0,2.074,0,3.076,0l1.514,0h1.3c1.11,0,2.22.006,3.321-.009a2.877,2.877,0,0,0,.457.006,2.533,2.533,0,1,0-.351-5.053c-3.128-.019-6.244-.022-9.314,0-.127-.006-.2-.009-.274-.009h-.037a2.5,2.5,0,0,0-2.435,2.547c0,.068,0,.128.009.193A2.546,2.546,0,0,0,29.337,37.029Z",
    transform: "translate(21.48 47.925)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5963",
    "data-name": "Caminho 5963",
    d: "M27.087,35.51c-3.3-.056-6.63-.056-9.917,0a2.49,2.49,0,0,0-2.491,2.482,2.54,2.54,0,0,0,2.534,2.5h.037c1.076.012,2.124.009,3.175,0l1.586,0,1.437,0c1.175.006,2.348.012,3.526-.016H27a2.481,2.481,0,0,0,2.5-2.447A2.447,2.447,0,0,0,27.087,35.51Z",
    transform: "translate(-2.99 55.069)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5964",
    "data-name": "Caminho 5964",
    d: "M20.642,37.981l0,.106a2.5,2.5,0,0,0,2.625,2.407c1.1.006,2.152,0,3.2,0l1.586,0,1.645,0c1,0,1.993,0,2.992,0h.022l.121.006h.081a2.548,2.548,0,0,0,2.538-2.466v-.149a2.5,2.5,0,0,0-2.6-2.382c-3.219-.044-6.443-.044-9.625,0h-.149a2.464,2.464,0,0,0-2.435,2.478",
    transform: "translate(9.175 55.072)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5965",
    "data-name": "Caminho 5965",
    d: "M38.826,35.51c-3.259-.053-6.515-.056-9.727,0h-.233A2.412,2.412,0,0,0,26.6,38.029v.134a2.52,2.52,0,0,0,2.584,2.332c1.092.009,2.143,0,3.194,0l1.583,0,2.161,0c.858.006,1.72.006,2.584.006a2.553,2.553,0,0,0,2.659-2.423v-.267a2.441,2.441,0,0,0-2.538-2.3Z",
    transform: "translate(21.485 55.07)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5966",
    "data-name": "Caminho 5966",
    d: "M20.55,13.722a2.522,2.522,0,0,0,1.881.51c1.95,0,3.775,0,5.616,0l2.761,0,2.957,0c1.776,0,3.548,0,5.327,0a3,3,0,0,0,.709,0A2.563,2.563,0,0,0,42.06,11.38a2.558,2.558,0,0,0-2.849-2.214c-5.616,0-11.136,0-16.656.006-.143-.012-.264-.019-.373-.019a2.589,2.589,0,0,0-.277.012l-.137.016a2.549,2.549,0,0,0-1.219,4.54Z",
    transform: "translate(6.894 0.636)",
    fill: "#008780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5967",
    "data-name": "Caminho 5967",
    d: "M39.428,12.685c-5.722-.028-11.475-.028-17.15,0l-.174,0h-.009a2.511,2.511,0,0,0-2.513,2.5c0,.04,0,.09.006.14a2.551,2.551,0,0,0,.889,1.757,2.487,2.487,0,0,0,1.857.6c1.922,0,3.785,0,5.65,0l2.8,0,2.395,0q3.041,0,6.1-.006l.106.006a2.67,2.67,0,0,0,1.866-.709A2.481,2.481,0,0,0,42,15.22a1.918,1.918,0,0,0,0-.227A2.423,2.423,0,0,0,39.428,12.685Z",
    transform: "translate(6.935 7.846)",
    fill: "#008780"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9760",
    "data-name": "Grupo 9760",
    transform: "translate(578 254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_429",
    "data-name": "Elipse 429",
    transform: "translate(0 0.283)",
    fill: "none",
    stroke: "#e00017",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_699",
    "data-name": "Linha 699",
    x1: 106.997,
    y2: 106.997,
    transform: "translate(26.499 26.885)",
    fill: "none",
    stroke: "#e00017",
    strokeWidth: 10
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAntiFraud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_anti_fraud.79327195.svg";
export { ForwardRef as ReactComponent };